/* eslint-disable */



// while running locally uncomment the below code and comment the code from Line Number 20 to 28.


// const awsmobile = {
    
//     "aws_project_region": "ap-south-1",
//     "aws_cognito_identity_pool_id": "ap-south-1:dfa018ae-7c57-46f9-850b-943fb6dbdf5e",
//     "aws_cognito_region": "ap-south-1",
//     "aws_user_pools_id": "ap-south-1_NJ2g0iww5",
//     "aws_user_pools_web_client_id": "en115bkcmtouo8mc0jrgh2mvu",
//     "oauth": {}
// };

// while making pull request / merging code comment the code from Line number 7 to 15

const awsmobile = {
    
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": process.env.VUE_APP_IDENTITYID,
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": process.env.VUE_APP_USERPOOLID,
    "aws_user_pools_web_client_id": process.env.VUE_APP_CLIENTID,
    "oauth": {}
};

export default awsmobile;